export const defaultOwnerOfficerObject = {
    state: null,
    locNumber: null,
    name: null,
    dateOfBirth: null,
    title: null,
    ownershipPercentage: null,
    duties: null,
    incExc: 'Exclude',
    payroll: null
};

export default [defaultOwnerOfficerObject];
  